/**
 * This is a Wrap component to use the usePriceContext hook with the Price component.
 * With this, we don't need to implement/use the usePricesContext every time we want to pass the course.prices to the Price component
 */

import * as React from 'react';

import Loader from 'crehana-ui/Loader';
import Price from 'crehana-ui/Text/Price';
import { PriceProps } from 'crehana-ui/Text/PriceTypes';

import { usePricesContext } from 'Jsx/CourseDetail/Context/Prices';

const CourseDetailPrice: React.FC<Partial<PriceProps>> = props => {
  const { loading, prices } = usePricesContext();

  if (loading || !prices) {
    return (
      <div className="flex justify-center items-center min-h-80 w-full">
        <Loader />
      </div>
    );
  }

  return (
    <Price
      currency={prices.currencySymbol}
      discount={`${prices.discount}% dto.`}
      price={prices.price}
      realPrice={prices.realPrice}
      realPriceColor="gray-dark"
      {...props}
    />
  );
};

export default CourseDetailPrice;
